const importAll = r => {
    let images = {};
    r.keys().forEach((item, i) => { images[item.replace('./', '')] = r(item); });
    return images
};

importAll(require.context('./passages', true, /\.js/));